"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _Constants = require("../../Constants");

var _IconConstants = require("UIComponents/icon/IconConstants");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _SVGTextIconStyle = _interopRequireDefault(require("./SVGTextIconStyle"));

var _SVGWrapper = _interopRequireDefault(require("./SVGWrapper"));

var AVATAR_RESPONSIVE_CENTER = 10;
var AVATAR_ICON_LARGEST_SIZE = _Constants.AVATAR_SIZES['xl'];
var AVATAR_CENTER_MULTIPLYER = AVATAR_RESPONSIVE_CENTER / AVATAR_ICON_LARGEST_SIZE;
var AVATAR_TEXT_MULTIPLIER = 0.37;

var SVGIconEdit = function SVGIconEdit(_ref) {
  var wrapperProps = _ref.wrapperProps,
      size = _ref.size;
  var avatar_y = size ? size * AVATAR_CENTER_MULTIPLYER : AVATAR_RESPONSIVE_CENTER;
  var icon_size = size * AVATAR_TEXT_MULTIPLIER;
  var avatar_style = size ? {
    fontSize: icon_size + "px",
    fontWeight: "" + (icon_size > _IconConstants.ICON_SIZES.medium ? 'bold' : 'normal')
  } : {};
  var SVGIconEditStyle = Object.assign({}, avatar_style);
  SVGIconEditStyle.fontSize = size * (AVATAR_TEXT_MULTIPLIER / 1.25) + "px";
  return _react.default.createElement(_SVGWrapper.default, (0, _extends2.default)({
    className: "overlay-content"
  }, wrapperProps), _react.default.createElement(_SVGTextIconStyle.default, {
    x: 0,
    y: avatar_y,
    style: avatar_style
  }, "edit"));
};

SVGIconEdit.propTypes = {
  size: _propTypes.default.number.isRequired,
  wrapperProps: _propTypes.default.object.isRequired
};
var _default = SVGIconEdit;
exports.default = _default;
module.exports = exports.default;